/**
 * Email Status Logs — Company Admin view.
 *
 *  Tenant-scoped feed of every outbound email this organisation has
 *  produced (welcome, invitation, password-reset, billing, etc.). The
 *  backend route filters to `req.user.tenantId` so a CA can never see
 *  another org's mail.
 *
 *  Renders the shared <SentEmailsView /> — the same body the Super
 *  Admin "Sent Emails" page uses — pointed at the tenant-scoped
 *  `/admin/email-logs` endpoint. This wrapper owns the page's own
 *  breadcrumb, title and help.
 */
import { Mail } from 'lucide-react'
import { Breadcrumb } from '../../components/Breadcrumb'
import { SentEmailsView } from '../../components/SentEmailsView'

export function AdminEmailLogsPage() {
  return (
    <div>
      <Breadcrumb current="Email Status Logs" />

      <div className="mb-6">
        <h1 className="font-display text-3xl text-[color:var(--color-ink-strong)] flex items-center gap-3">
          <Mail size={22} className="text-[color:var(--color-accent-strong)]" />
          Email Status Logs
        </h1>
        <p className="mt-1 text-sm text-[color:var(--color-ink-muted)]">
          Every outbound email this company has sent, with its
          delivery status.
        </p>
      </div>

      <SentEmailsView apiBase="/admin/email-logs" />
    </div>
  )
}
